import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ContactBackgrounddamask from '../assets/images/Black_damask.webp';
import Facebook from '../assets/images/FB_Icon.png';
import Instagram from '../assets/images/Insta_dark_Icon.png';
import Tiktok from '../assets/images/tiktok-icon-dark.png';
import WorkScheduleDark from './WorkScheduleDark';

const ContactSectionDark = () => {
  const [isScheduleExpanded, setIsScheduleExpanded] = useState(false);
  
  // Initialize Leaflet map
  useEffect(() => {
    // Load Leaflet CSS
    if (!document.querySelector('link[href*="leaflet.css"]')) {
      const leafletCSS = document.createElement('link');
      leafletCSS.rel = 'stylesheet';
      leafletCSS.href = 'https://unpkg.com/leaflet/dist/leaflet.css';
      document.head.appendChild(leafletCSS);
    }

    // Load Leaflet JS
    const loadLeaflet = () => {
      if (!window.L) {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/leaflet/dist/leaflet.js';
        script.onload = () => {
          initMap();
        };
        document.body.appendChild(script);
      } else {
        initMap();
      }
    };

    const initMap = () => {
      const mapElement = document.getElementById('contact-dark-map');
      if (!mapElement || !window.L) return;

      // Check if map is already initialized
      if (mapElement._leaflet_id) {
        return;
      }

      try {
        const L = window.L;
        const map = L.map('contact-dark-map').setView([40.69, -75.21], 13);

        // Light/Minimal map (Carto Light, free)
        const lightMap = L.tileLayer(
          'https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/">CARTO</a>',
            subdomains: 'abcd',
            maxZoom: 19
        });

        // Satellite map (ESRI free tiles)
        const satelliteMap = L.tileLayer(
          'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
            attribution: 'Tiles &copy; <a href="https://www.esri.com/">Esri</a>'
        });

        // Add default layer
        lightMap.addTo(map);

        // Black marker icon
        const blackIcon = L.icon({
          iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png",
          shadowUrl: "https://unpkg.com/leaflet/dist/images/marker-shadow.png",
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41]
        });

        // Marker at exact location
        L.marker([40.6889, -75.2096], {icon: blackIcon}).addTo(map)
          .bindPopup("Hair To Dye For<br>200 Northampton St, Easton, PA 18042")
          .openPopup();

        // Layer control (Map / Satellite)
        const baseMaps = {
          "Map": lightMap,
          "Satellite": satelliteMap
        };
        L.control.layers(baseMaps).addTo(map);

        // Store map instance for cleanup
        mapElement._leafletMap = map;
      } catch (error) {
        console.error('Error initializing map:', error);
      }
    };

    // Load Leaflet after a small delay to ensure DOM is ready
    setTimeout(loadLeaflet, 100);

    // Cleanup function
    return () => {
      const mapElement = document.getElementById('contact-dark-map');
      if (mapElement && mapElement._leafletMap) {
        try {
          mapElement._leafletMap.remove();
          delete mapElement._leafletMap;
        } catch (error) {
          console.error('Error cleaning up map:', error);
        }
      }
    };
  }, []);

  return (
    <section className="flex flex-col lg:flex-row relative w-full min-h-screen">
      {/* Left side - Contact Information */}
      <div 
        className="w-full lg:w-1/2 flex flex-col p-6 sm:p-8 lg:p-16 relative z-10 min-h-[600px] lg:min-h-screen"
        style={{
          backgroundImage: `url(${ContactBackgrounddamask})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#000000'
        }}
      >
        <div className="w-full flex flex-col items-center flex-grow">
          {/* Top Section */}
          <div className="w-full flex flex-col items-center mb-8 lg:mb-12">
            {/* Welcome Text - Responsive */}
            <h2 
              className="font-quentin text-[#4B3E29] mb-0 relative"
              style={{
                fontFamily: 'Quentin',
                fontWeight: 400,
                fontStyle: 'normal',
                lineHeight: '1',
                letterSpacing: '0',
                textAlign: 'center',
                fontSize: 'clamp(60px, 12vw, 160px)' // Responsive font size
              }}
            >
              Welcome
            </h2>
            
            {/* SINCE 2005 - Positioned relative to Welcome */}
            <p 
              className="text-[#FAFAFA] uppercase tracking-[0.2em] mb-4 text-xs sm:text-sm md:text-base"
              style={{
                fontFamily: 'Montserrat',
                fontWeight: 400,
                marginTop: '-10px'
              }}
            >
              SINCE 2005
            </p>
            
            {/* Main Heading - Responsive */}
            <h3 
              className="text-white font-bold uppercase px-2"
              style={{
                fontFamily: 'Montserrat',
                fontWeight: 700,
                letterSpacing: '0.04em',
                lineHeight: '1.2',
                fontSize: 'clamp(20px, 5vw, 40px)' // Responsive font size
              }}
            >
              VISIT HAIR TO DYE FOR<br className="sm:hidden" /> IN EASTON
            </h3>
          </div>
          
          {/* Scrollable Content Container */}
          <div className="w-full max-w-[500px] px-4 overflow-y-auto flex-grow">
            {/* Convenient Location */}
            <p 
              className="text-[#FAFAFA] font-semibold uppercase tracking-[0.2em] mb-4 text-xs sm:text-sm md:text-base text-center"
              style={{
                fontFamily: 'Montserrat',
                fontWeight: 600
              }}
            >
              CONVENIENT LOCATION, FLEXIBLE HOURS
            </p>
            
            {/* Description - Responsive padding */}
            <p 
              className="text-[#FAFAFA] mb-6 sm:mb-8 px-4 sm:px-8 lg:px-12 text-sm sm:text-base text-center"
              style={{
                fontFamily: 'Montserrat',
                fontWeight: 400,
                lineHeight: '1.6'
              }}
            >
              Find us in downtown Easton with easy booking options by phone. 
              Check our hours and location below or get directions on Google Maps.
            </p>
            
            {/* Work Schedule Component - Dark Theme */}
            {/* <WorkScheduleDark onExpandChange={setIsScheduleExpanded} /> */}
                     <a
  href="/contact"
  style={{
    color: "#C7A064",
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "156%", // 24.96px
    letterSpacing: "3.2px",
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
    textDecorationSkipInk: "none",
    textDecorationThickness: "auto",
    textUnderlineOffset: "auto",
    textTransform: "uppercase",
    display: "block",
    marginTop: "20px",
    marginBottom: "20px", 
  }}
>
  View Working hours
</a>
            {/* Phone Number - Responsive */}
            <div className="mb-6 text-center">
              <a 
                href="tel:+16109233530" 
                className="text-[#C7A064] hover:opacity-80 transition-opacity font-bold text-lg sm:text-xl"
                style={{
                  fontFamily: 'Montserrat'
                }}
              >
                1 (610) 923-3530
              </a>
            </div>
            
            {/* Divider */}
            <div className="w-32 sm:w-48 md:w-64 h-px mx-auto mb-6 bg-gray-700"></div>
            
            {/* Address */}
            <p 
              className="text-[#FAFAFA] mb-8 text-base sm:text-lg md:text-xl text-center"
              style={{
                fontFamily: 'Montserrat',
                fontWeight: 400
              }}
            >
              200 Northampton St, Easton,<br className="sm:hidden" /> PA 18042
            </p>
            
            {/* Social Media Icons */}
            <div className="flex justify-center space-x-4 sm:space-x-6 mb-8">
              <button 
                onClick={() => window.open('https://www.facebook.com/h2d4easton', '_blank', 'noopener,noreferrer')}
                className="w-10 h-10 sm:w-12 sm:h-12 bg-[#F2EADC] rounded-full flex items-center justify-center hover:bg-[#E8DCC4] transition-colors shadow-lg"
                aria-label="Visit our Facebook page"
              >
                <img src={Facebook} alt="Facebook" className="w-10 h-10 sm:w-12 sm:h-12" />
              </button>
              <button 
                onClick={() => window.open('https://www.instagram.com/h2d4easton/', '_blank', 'noopener,noreferrer')}
                className="w-10 h-10 sm:w-12 sm:h-12 bg-[#F2EADC] rounded-full flex items-center justify-center hover:bg-[#E8DCC4] transition-colors shadow-lg"
                aria-label="Visit our Instagram page"
              >
                <img src={Instagram} alt="Instagram" className="w-10 h-10 sm:w-12 sm:h-12" />
              </button>
              <button 
                onClick={() => window.open('https://www.tiktok.com/@h2d4easton', '_blank', 'noopener,noreferrer')}
                className="w-10 h-10 sm:w-12 sm:h-12 bg-[#F2EADC] rounded-full flex items-center justify-center hover:bg-[#E8DCC4] transition-colors shadow-lg"
                aria-label="Visit our TikTok page"
              >
                <img src={Tiktok} alt="TikTok" className="w-10 h-10 sm:w-12 sm:h-12" />
              </button>
            </div>
            
            {/* CTA Button - Responsive */}
            <div className="text-center pb-8">
              <a
                href="tel:+16109233530"
                className="inline-block text-[#C7A064] hover:text-[#B3925A] transition-colors underline font-bold uppercase tracking-[0.2em] sm:tracking-[0.32em] text-xs sm:text-sm md:text-base"
                style={{
                  fontFamily: 'Montserrat',
                  fontWeight: 700,
                  textDecorationThickness: '1px',
                  textUnderlineOffset: '6px'
                }}
              >
                CALL TO BOOK NOW
              </a>
            </div>
          </div>
        </div>
      </div>
      
      {/* Right side - Interactive Map */}
      <div className="w-full lg:w-1/2 h-[400px] sm:h-[500px] lg:h-screen bg-gray-100 flex items-center justify-center">
        <div id="contact-dark-map" className="w-full h-full"></div>
      </div>
    </section>
  );
};

export default ContactSectionDark;